import BaseResponse from 'base/base.response';
import { LoginResponse } from 'model/account/account.model';
import { AuthenRequest } from 'model/auth/roles.model';
import { backendAxiosInstance } from 'api/backendClient';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';

export const loginApi = async (request: AuthenRequest): Promise<BaseResponse<LoginResponse>> => {
  try {
    const response = await backendAxiosInstance.post(`${BACKEND_URL}/api/v1/auth/login`, {
      user_name: request.user_name,
      password: request.password,
    });

    const backendData = response.data;

    if (!backendData.success) {
      return {
        code: 401,
        message: backendData.error || 'Login failed',
        data: null as any,
        response_time: new Date().toISOString(),
        errors: [backendData.error || 'Invalid credentials'],
        request_id: '',
      };
    }

    const loginData = backendData.data;

    return {
      code: 200,
      message: 'Login successful',
      data: {
        access_token: loginData.access_token,
        token_type: loginData.token_type,
        expires_in: loginData.expires_in,
        user: loginData.user,
      },
      response_time: new Date().toISOString(),
      errors: [],
      request_id: '',
    };
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.error || error?.message || 'Network error';

    return {
      code: error?.response?.status || 500,
      message: errorMsg,
      data: null as any,
      response_time: new Date().toISOString(),
      errors: [errorMsg],
      request_id: '',
    };
  }
};
